<template>
    <!--外层box-->
    <div class="diagram">
        <div class="mask" v-if="!isFull"></div>
        <div class="move-box">
            <iframe v-if="show" ref="iframe" style="width:100%;height:100%" class="small" :src="src"
                frameborder="0"></iframe>
        </div>
        <div class="tableContainer">
            <slot name="loopDetail" />
        </div>
        <div :class="$store.state.projectId !=5? 'btn row-center': 'btn row-center btnb'" @click="cancelFull">
            <img v-if="$store.state.projectId !=5" src="../assets/img/full_cancel.png" alt="取消全屏">
            <img v-else src="../assets/img/escaOut.png" alt="取消全屏">
            <span>取消全屏</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Diagram",
        props: {
            src: String,
            isFull: Boolean
        },
        data() {
            return {
                show: true,
            }
        },
        mounted() {
            this.iframeWin = this.$refs.iframe.contentWindow;
            window.addEventListener("message", this.handleMessage);
        },
        methods: {
            handleMessage(event) {
                // console.log(event);
                const data = event.data;
                switch (data.cmd) {
                    case "SwitchingClosing":
                        this.$emit('loopDetail', data.cmd, data.loopName)
                        break;
                    case "RealTimeData":
                        this.$emit('loopDetail', data.cmd, data.loopName)
                        break;
                }
            },
            full() {
                this.$emit("onFull")
            },
            cancelFull() {
                this.$emit("onCancelFull")
                this.show = false
                this.$nextTick(() => {
                    this.show = true
                })
            },
        }
    }
</script>

<style scoped lang="less">
    .full {

        .btn {
            top: 0 !important;
            bottom: -83vh !important;
            right: 2vw !important;
        }
    }


    .diagram {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        background-color: rgba(0, 0, 0, 0);

        .mask {
            width: 100%;
            height: 100%;
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99;
        }

        .move-box {
            width: 100%;
            height: 100%;
            position: relative;
            background-color: #000000;
        }

        .small {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            /*transition: all 0.1s;*/
        }

        .btn {
            .wh(0, -36);
            position: absolute;
            top: @h;
            right: @w;
            z-index: 99999;
            color: #ffffff;
            font-size: 18rem;
            cursor: pointer;

            img {
                .wh(16, 16);
                width: @w;
                height: @h;
                margin-right: 7 / 1920 * 100vw;
            }
        }
        .btnb {
            color: #000;
        }
    }

    .tableContainer {
        z-index: 99;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>